import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'

import { AggregationAnalysisFacade } from '~/core/features'

export const aggregationAnalysisQuarterDataResolver: ResolveFn<void> = () => {
  return inject(AggregationAnalysisFacade).getAggregationAnalysisQuarterData()
}
